/* eslint-disable dot-notation */
import BaseComponent from 'scripts/BaseComponent.js';
import UnderlayHelper from '../../global/underlay-helper';
import { AccessibilityHelper } from '../../../scripts/accessibility/accessibilityHelper';
import Cart from '../../cart/cart';

export default class AddCardModal extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      closeBtn: '.js-closeAddCard',
      addCardBtn: '.js-addCardBtn',
      skipCardBtn: '.js-skipCardBtn',
      cardMessage: '.js-addCardMessage',
      cardTitle: '.js-addCardTitle',
    };

    this.dom = {
      $component: component,
      $closeBtn: this.$get(this.refs.closeBtn),
      $addCardBtn: this.$get(this.refs.addCardBtn),
      $skipCardBtn: this.$get(this.refs.skipCardBtn),
      $cardMessage: document.querySelector(this.refs.cardMessage),
      $cardTitle: document.querySelector(this.refs.cardTitle),
    };

    this.state = {
      id: null,
      properties: null,
      openClass: 'is-open',
      showClass: 'show',
      animationDuration: 500,
      openAddCardModalEvent: 'openaddcardmodal',
      underlayHelper: new UnderlayHelper({ overNav: true }),
      accessibilityHelper: new AccessibilityHelper(),
      focusTrap: null,
    };

    this.mount();
  }

  mount() {
    const { dom, state } = this;
    super.mount();

    this.setOnCustomEvent(state.openAddCardModalEvent, this.setProdProps);
    this.setClick(dom.$closeBtn, this.closeModal);
    this.setClick(dom.$addCardBtn, this.addCard);
    this.setClick(dom.$skipCardBtn, this.skipCardAdd);
    state.underlayHelper.addClickListener(this.closeModal.bind(this));
    state.focusTrap = state.accessibilityHelper.buildFocusTrap([dom.$component]);
  }

  setProdProps({ detail: { id, properties } }) {
    const { state } = this;

    state.id = id;
    state.properties = properties;
    this.openModal();
  }

  openModal() {
    const { dom, state } = this;

    dom.$component.classList.add(state.openClass);
    setTimeout(() => {
      dom.$component.classList.add(state.showClass);
    }, 0);

    dom.$component.setAttribute('aria-hidden', 'false');
    dom.$component.setAttribute('aria-expanded', 'true');
    state.underlayHelper.open();
    state.focusTrap.set();
  }

  closeModal() {
    const { dom, state } = this;

    dom.$component.classList.remove(state.showClass);
    setTimeout(() => {
      dom.$component.classList.remove(state.openClass);
      dom.$component.classList.remove(state.infoExpandedClass);
    }, state.animationDuration);

    dom.$component.setAttribute('aria-hidden', 'true');
    dom.$component.setAttribute('aria-expanded', 'false');
    state.underlayHelper.close();
    state.focusTrap.unset();
  }

  addCard() {
    const { dom, state: { id, properties } } = this;

    properties['greeting_card_style'] = dom.$cardTitle.textContent;

    if (dom.$cardMessage.value) {
      properties['greeting_card_message'] = dom.$cardMessage.value;
    }

    this.closeModal();
    Cart.addItem(id, properties);
  }

  skipCardAdd() {
    const { state: { id, properties } } = this;

    this.closeModal();
    Cart.addItem(id, properties);
  }
}
